import { Deserializable } from './deserializable';

export class Equipment implements Deserializable {
    currentMachineNo: string;
    customerMachineNo?: string;
    equipmentId: number;
    model?: string;
    pLCResponsiblePerson: string;
    primaryFuel: string;
    productFamily: string;
    rDSResponsiblePerson?: string;
    rEResponsiblePerson: string;
    responsiblePLC: string;
    salesForceEquipmentId: string;
    technology: string;
    trainId: number;
    salesForceUnitId: number;
    image: string;
    secondImage: string;
    deserialize(input: any) {
        Object.assign(this, input);
        return this;
    }

    /**
     * Return the property used to match the lds data sources
     */
    getLdsUniqueId() {
        return this.salesForceUnitId;
    }
}



// WEBPACK FOOTER //
// ./src/models/equipment.ts